/* Smooth scroll vers la section description sur la page produit. */
const blockDescription = document.querySelector('.shopify-section--specification-table');
function gotoDescription() {
    if (blockDescription) {
        blockDescription.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    } 
}

/* Ajouter le nombre de slider (1/4) sur le caroussel des produits associés (page produit) */
function initProductCarousels() {
  const carousels = document.querySelectorAll('.horizontal-product-list-carousel');
  if (!carousels.length) return false;

  carousels.forEach(productCarousel => {
    if (!productCarousel || !productCarousel.parentElement) return;

    const parent = productCarousel.parentElement;
    const productCarouselCounter = parent.querySelector('span[id$="-counter"]');
    const carouselProducts = productCarousel.querySelectorAll('.horizontal-product');
    if (!carouselProducts.length) return;

    let current = 1;
    function updateCounter() {
      if (productCarouselCounter) productCarouselCounter.textContent = `${current} / ${carouselProducts.length}`;
    }

    productCarousel.addEventListener('slideChange', e => {
      current = (e && e.detail && typeof e.detail.index === 'number') ? e.detail.index + 1 : current;
      updateCounter();
    });

    parent.querySelectorAll('[is="prev-button"], [is="next-button"]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.getAttribute('is') === 'next-button') {
          if (current < carouselProducts.length) current += 1;
        } else if (btn.getAttribute('is') === 'prev-button') {
          if (current > 1) current -= 1;
        }
        updateCounter();
      });
    });

    updateCounter();
  });

  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  if (initProductCarousels()) return;

  // Si pas trouvé, observer le DOM pour les insertions
  const observer = new MutationObserver((mutations, obs) => {
    if (initProductCarousels()) {
      obs.disconnect();
    }
  });

  observer.observe(document.documentElement || document.body, {
    childList: true,
    subtree: true
  });

});

/* Mise à jour des badges produit lors du changement de variante */
function initProductBadgesListener() {
  const variantDataScript = document.getElementById('product-variants-data');
  const bestSellingBadge = document.querySelector('best-selling-badge');
  if (!variantDataScript) return;

  try {
    const data = JSON.parse(variantDataScript.textContent);
    const variantMap = {};
    data.variants.forEach(v => {
      variantMap[v.id] = v;
    });

    const productId = data.productId;
    const discountMode = window.themeVariables?.settings?.discountMode || 'percentage';

    const updatePromoBadge = (selectedVariant) => {
      if (!selectedVariant) return;

      const badgesContainer = document.querySelector(`#product-badges-container-${productId}`);
      const badgesRoot = badgesContainer?.parentElement;
      if (!badgesRoot) return;

      let onSaleBadge = badgesRoot.querySelector('on-sale-badge');
      const showOnSaleBadge = selectedVariant.compare_at_price > selectedVariant.price;

      if (!showOnSaleBadge) {
        if (onSaleBadge) onSaleBadge.remove();
        return;
      }

      const savings = discountMode === 'amount'
        ? window.Shopify.formatMoney(selectedVariant.compare_at_price - selectedVariant.price)
        : `${Math.round((selectedVariant.compare_at_price - selectedVariant.price) * 100 / selectedVariant.compare_at_price)}%`;

      if (!onSaleBadge) {
        onSaleBadge = document.createElement('on-sale-badge');
        onSaleBadge.className = 'badge badge--product badge--on-sale';
        badgesRoot.insertBefore(onSaleBadge, badgesContainer);
      }

      onSaleBadge.innerHTML = window.themeVariables.strings.productDiscountBadge.replace('__SAVINGS__', savings);
    };

    const updateBadge = (selectedVariant) => {
      const variantId = selectedVariant?.id;
      // Merge avec les données Liquid (price, compare_at_price) si absent (ex: init)
      const variantData = variantMap[variantId] || {};
      const mergedVariant = Object.assign({}, variantData, selectedVariant);
      const badges = variantData.badges || [];
      const badgesContainer = document.querySelector(`#product-badges-container-${productId}`);
      if (!badgesContainer) return;
      const badgesHtml = badges.map(b => `<span class="badge badge--product badge--primary">${b}</span>`).join('');
      badgesContainer.innerHTML = badgesHtml ? `${badgesHtml}` : '';

      updatePromoBadge(mergedVariant);

      if (bestSellingBadge) {
        if (badges.some(b => b.includes('Fin de série'))) {
          bestSellingBadge.style.display = 'none';
        } else {
          bestSellingBadge.style.display = '';
        }
      }
    };

    document.addEventListener('variant:change', (e) => {
      const selectedVariant = e.detail?.variant;
      if (!selectedVariant) return;
      updateBadge(selectedVariant);
    });

    // Chercher l'input caché qui contient l'id du variant sélectionné
    let initialVariantId = null;
    const variantInput = document.querySelector("input[name='id']");
    if (variantInput && variantInput.value) {
      initialVariantId = variantInput.value;
    } else if (data.variants.length > 0) {
      initialVariantId = data.variants[0].id;
    }
    if (initialVariantId) {
      const initialId = parseInt(initialVariantId, 10);
      updateBadge(variantMap[initialId] || { id: initialId });
    }
  } catch (e) {
    console.warn('Error initializing product badges:', e);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initProductBadgesListener();
});

// Produit Revêtement - Calculateur surface/quantité
window.calcSurface = function() {
  const length = parseFloat(document.getElementById('input-length')?.value);
  const width = parseFloat(document.getElementById('input-width')?.value);
  const surfaceInput = document.getElementById('input-surface');
  if (length > 0 && width > 0) {
    let surface = length * width;
    // Affiche sans ,00 si entier, sinon 2 décimales
    surfaceInput.value = Number.isInteger(surface) ? surface : surface.toFixed(2);
  } else {
    surfaceInput.value = '';
  }
  window.calcQuantity();
};

window.calcQuantity = function() {
  const surface = parseFloat(document.getElementById('input-surface')?.value);
  const unitPrice = parseFloat(document.querySelector('[data-unit-price]')?.getAttribute('data-unit-price'));
  const productPrice = parseFloat(document.querySelector('[data-product-price]')?.getAttribute('data-product-price'));
  const quantityInput = document.getElementById(window.productFormId ? window.productFormId + '-quantity' : 'quantity');
  if (surface > 0 && unitPrice > 0 && productPrice > 0) {
    const total = unitPrice * surface;
    const qty = Math.ceil(total / productPrice);
    quantityInput.value = qty;
  }
};

window.attachCalculatorEvents = function(productFormId) {
  window.productFormId = productFormId;
  const inputLength = document.getElementById('input-length');
  const inputWidth = document.getElementById('input-width');
  const inputSurface = document.getElementById('input-surface');
  if (inputLength) inputLength.addEventListener('input', window.calcSurface);
  if (inputWidth) inputWidth.addEventListener('input', window.calcSurface);
  if (inputSurface) inputSurface.addEventListener('input', window.calcQuantity);
};